import Axios from 'axios';
import qs from 'querystring';
import get from 'lodash.get';
import { datadogRum } from '@datadog/browser-rum-slim';

const PasswordReset = (values, callback) => {
  const { _csrf, email, ticket, newPassword, confirmNewPassword } = values;
  if (_csrf === undefined || ticket === undefined || email === undefined) {
    // user will see
    // "Error occurred. Please try again."
    // as front-end parser is not reading
    // error.message
    if (callback) {
      callback(new Error('Unexpected error occurred.'));
    }
    return;
  }
  if (newPassword !== confirmNewPassword) {
    // may remove this
    // as validation is handled
    // on front-end by Yup
    if (callback) {
      callback(new Error('Passwords does not match.'));
    }
    return;
  }
  Axios({
    method: 'post',
    url: `https://${typeof window !== 'undefined' && window.location.hostname}/lo/reset`,
    data: qs.stringify(values),
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
    .then((res = {}) => {
      let returnAppLoginUrl = null;
      if (res.data && typeof res.data.result_url === 'string') {
        returnAppLoginUrl = res.data.result_url;
      }
      if (callback) {
        callback(null, returnAppLoginUrl);
      }
    })
    .catch((error) => {
      const errorDesc = get(error, 'response.data.description');
      if (errorDesc) {
        const derivedError = new Error(errorDesc);
        datadogRum.addError(derivedError);
      } else {
        datadogRum.addError(error);
      }

      // Axios enhances its error handling by
      // adding error response to the error caught
      // use error.response.data
      // to get the correct error message
      // or else customer will get generic error message
      // "Error occurred. Please try again."
      // from front-end parser
      if (callback) {
        callback(errorDesc ? get(error, 'response.data') : error);
      }
    });
};

export default PasswordReset;
